import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { createAvaturnExport } from '~/api';
import { SECOND } from '~/constants';
import useToast from '~/store/useToast';

const useCreateExportMutation = () => {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: createAvaturnExport,
    onError: (error) => {
      console.error(error);
      showToast('error', 'export avatar error');
    },
    retryDelay: 1.2 * SECOND,
    retry: 200,
  });
};

export default useCreateExportMutation;
